<div
  class="z-50 flex h-14 w-full items-center justify-between px-4"
  [ngClass]="
    fullScreen()
      ? 'absolute !bg-none'
      : isSimulationView()
        ? 'bg-bo-black/70 backdrop-blur-lg'
        : 'bg-bo-secondary'
  "
>
  <div class="bo-subheader flex-1 !text-bo-white">
    @if (!fullScreen()) {
      <span>
        {{ sceneStore.data().name }}
      </span>
    }
  </div>

  @if (sandbox && isSimulationView() && !fullScreen()) {
    <div class="z-50 flex h-full justify-center gap-4 p-2">
      @if (!appService.trackingMode()) {
        @if (!appService.demoMode()) {
          <svg-icon
            class="ml-2 self-center fill-yellow-500"
            src="fa-icons/folder-arrow-up.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="uploader.click()"
            data-e2e="button-uploadVideo"
          />
        } @else {
          <svg-icon
            class="ml-2 self-center fill-bo-red"
            src="fa-icons/folder-xmark.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="removeDemoMovie()"
          />
        }
      }
      @if (!appService.trackingMode()) {
        <svg-icon
          src="fa-icons/stethoscope.svg"
          class="ml-2 self-center fill-bo-orange"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="mltracking.click()"
        />
      } @else {
        <svg-icon
          src="icons/stethoscope-close.svg"
          class="ml-2 self-center fill-bo-red"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="stopTrackingMode()"
        />
      }
    </div>
    <input hidden type="file" #uploader (change)="selectDemoMovie($event)" />
    <input
      hidden
      type="file"
      #mltracking
      (change)="selectTracking($event)"
      webkitdirectory
      mozdirectory
    />
  }
  @if (sandbox && showSandbox() && !fullScreen()) {
    <div class="z-50 mr-4 flex h-full items-center gap-4 p-3">
      @if (!appService.trackingMode()) {
        <svg-icon
          class="ml-2 self-center fill-green-600"
          [ngClass]="{ 'fill-green-800': appService.showSceneLauncher() }"
          src="fa-icons/rocket-launch.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="
            appService.showSceneLauncher.set(!appService.showSceneLauncher())
          "
          data-e2e="button-sandbox"
        />
      }
      @if (isSimulationView() && appService.demoMode()) {
        @if (!appService.trackingMode()) {
          <svg-icon
            class="ml-2 self-center fill-green-600"
            src="fa-icons/rotate-right.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="appService.replayVideo.emit()"
          />
        }
        @if (!appService.trackingMode()) {
          <svg-icon
            class="ml-2 self-center fill-green-600"
            src="fa-icons/backward.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="appService.fastBackward.emit()"
          />
        }
        <svg-icon
          class="ml-2 self-center fill-green-600"
          src="fa-icons/pause.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="appService.pauseVideo.emit()"
        />
        @if (!appService.trackingMode()) {
          <svg-icon
            class="ml-2 self-center fill-green-600"
            src="fa-icons/forward.svg"
            [svgStyle]="{ 'height.px': 20 }"
            (click)="appService.fastForward.emit()"
          />
        }
      }
      <svg-icon
        class="ml-2 self-center fill-blue-600"
        [ngClass]="{ 'fill-blue-800': appService.showConsole() }"
        src="fa-icons/square-terminal.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="appService.showConsole.set(!appService.showConsole())"
      />
      @if (isSimulationView()) {
        <svg-icon
          class="ml-2 self-center fill-purple-500"
          [ngClass]="{ 'fill-purple-700': appService.debugMode() }"
          src="fa-icons/bug.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="appService.debugMode.set(!appService.debugMode())"
        />
      }
    </div>
  }
  @if (
    showHelpButton() || showFullScreenButton() || showExpandSideBarButton()
  ) {
    <div class="z-50 flex items-center gap-4">
      @if (showHelpButton() && !fullScreen()) {
        <button class="h-7" type="button" (click)="toggleSidebar()">
          <img src=" icons/help.svg" class="h-7" />
        </button>
      }
      @if (showExpandSideBarButton() && !showSideBar() && !fullScreen()) {
        <button class="z-50 h-7" type="button" (click)="toggleSidebar()">
          <img src=" icons/expand-side-bar.svg" class="h-7" />
        </button>
      }
      @if (showFullScreenButton()) {
        <button
          class="z-50 cursor-pointer"
          type="button"
          (click)="toggleFullscreen()"
        >
          <img
            [src]="
              fullScreen() ? 'icons/not-fullscreen.svg' : 'icons/fullscreen.svg'
            "
            class="h-7"
          />
        </button>
      }
    </div>
  }
</div>
